<template>
  <v-container>
    <CreateShowcase
      v-if="showCreateShowcase"
      @close="showCreateShowcase = false"
    ></CreateShowcase>
    <div
      v-if="$apollo.queries.listShowcases.loading"
      class="d-flex justify-center mb-6"
    >
      <v-progress-circular indeterminate color="grey"></v-progress-circular>
    </div>

    <div v-else-if="listShowcasesError">
      <v-alert dense outlined type="error">
        {{ listShowcasesError }}
      </v-alert>
    </div>

    <div v-else-if="listShowcases && listShowcases.showcases.length > 0">
      <v-card>
        <v-toolbar flat color="grey lighten-2">
          <LabelWithCount
            :count="showCaseCount"
            :fontsize="1.1"
            label="Showcases"
          ></LabelWithCount>
          <v-btn
            class="add-showcase-btn"
            fab
            small
            @click="showCreateShowcase = true"
          >
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
        </v-toolbar>
        <v-list two-line>
          <v-list-item-group active-class="blue--text">
            <template v-for="showcase in listShowcases.showcases">
              <v-list-item
                :key="showcase.showcaseId"
                :value="showcase"
                :to="{
                  path: showcasePath + '/' + showcase.showcaseId + ''
                }"
              >
                <v-list-item-content>
                  <v-list-item-title v-text="showcase.name"></v-list-item-title>
                  <v-list-item-subtitle
                    class="text--primary"
                    v-text="showcase.domain"
                  ></v-list-item-subtitle>
                  <v-list-item-subtitle
                    v-text="showcase.status"
                  ></v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list-item-group>
        </v-list>
      </v-card>
    </div>

    <div v-else class="d-flex justify-center mb-6">
      <v-card>
        <span style="color: grey; ">No Showcases to display.</span>
      </v-card>
    </div>
  </v-container>
</template>

<script>
import { LIST_SHOWCASES } from '../constants/query'
import LabelWithCount from './LabelWithCount'
import CreateShowcase from './showcase/forms/CreateShowcase'
import { DOMAIN_NAME } from '@/domain/showcases'
import { SHOWCASE_AUTOMATION_PATH } from '@/domain/showcases/routes/routes'

export default {
  name: 'ShowcaseList',
  components: {
    LabelWithCount,
    CreateShowcase
  },
  data: () => ({
    showCreateShowcase: false,
    listShowcases: null,
    listShowcasesError: null
  }),
  computed: {
    showCaseCount: function() {
      return this.listShowcases && this.listShowcases.showcases
        ? this.listShowcases.showcases.length
        : 0
    },
    showcasePath() {
      return SHOWCASE_AUTOMATION_PATH
    }
  },
  apollo: {
    $client: DOMAIN_NAME,
    listShowcases: {
      query: LIST_SHOWCASES,
      error(error) {
        this.listShowcasesError = JSON.stringify(error.message)
      }
    }
  }
}
</script>

<style scoped>
.add-showcase-btn {
  position: absolute;
  right: 10px;
}
</style>
